import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { ChevronDownIcon, MessageCircleIcon } from 'lucide-react';
import { Link } from 'react-router-dom';
import { PageCTA } from '../components/PageCTA';
const faqs = [{
  question: '¿Qué incluye exactamente la oferta de 350€?',
  answer: 'La oferta reúne una página web profesional, carta digital cuando aplica, diseño responsive, gestión y mantenimiento integral. Es un pago único por transferencia bancaria, sin cuotas mensuales ni costes ocultos.'
}, {
  question: '¿Cuánto suele durar el proceso?',
  answer: 'El tiempo depende de la complejidad y de la disponibilidad de materiales. Como referencia de planificación, un proyecto suele requerir entre dos y cuatro semanas desde que contamos con la información necesaria.'
}, {
  question: '¿Qué tengo que preparar antes de empezar?',
  answer: 'Necesitamos entender tu negocio, servicios, público y prioridades. Si ya tienes textos, logo o imágenes, ayudan a avanzar. Si no, definimos contigo qué información es imprescindible antes de diseñar.'
}, {
  question: '¿La web funciona bien en móvil?',
  answer: 'Sí. Diseñamos cada pantalla desde una perspectiva responsive para que la lectura, los contenidos y los llamados a la acción funcionen correctamente en móvil, tablet y escritorio.'
}, {
  question: '¿Qué ocurre después de publicar?',
  answer: 'El proyecto no se queda abandonado tras el lanzamiento. La oferta contempla gestión y mantenimiento para que tu presencia pueda mantenerse útil cuando necesites realizar cambios.'
}, {
  question: '¿Puedo contratar solo una parte del servicio?',
  answer: 'La propuesta está pensada como un sistema completo porque las piezas funcionan mejor conectadas. Si tienes una necesidad concreta, puedes escribirnos para valorar el mejor punto de partida.'
}, {
  question: '¿Para qué negocios está pensado?',
  answer: 'Es una propuesta especialmente útil para negocios locales, servicios, hostelería y profesionales que necesitan ordenar su presencia y comunicar mejor el valor de lo que hacen.'
}];
export function FAQPage() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return <div className="min-h-screen bg-[#0a0a0a] pt-24" data-id="element-347" data-mp="1iltj3tlw9wyq">
      <section className="border-b border-white/10 py-16 sm:py-24" data-id="element-348" data-mp="13yi5lm65k2vz">
        <div className="container mx-auto max-w-6xl px-6 md:px-12" data-id="element-349" data-mp="18pgnurapbb1v">
          <motion.div initial={{
          opacity: 0,
          y: 14
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.5
        }} className="grid gap-7 lg:grid-cols-[0.8fr_1.2fr] lg:items-end" data-id="element-350" data-mp="18qrr8q08igsg">
            <div data-id="element-351" data-mp="pziiiiyafw1x">
              <p className="eyebrow" data-id="element-352" data-mp="pxxm0nsey31f">Preguntas frecuentes</p>
              <h1 className="mt-5 text-4xl font-medium tracking-[-0.055em] text-white sm:text-6xl" data-id="element-353" data-mp="6d78ifflegqf">
                Todo lo que conviene saber antes de empezar.
              </h1>
            </div>
            <p className="max-w-2xl text-base leading-relaxed text-neutral-400 sm:text-lg" data-id="element-354" data-mp="gbd6wn26x4qj">
              Hemos reunido las dudas más habituales sobre alcance, proceso,
              precio y acompañamiento.
            </p>
          </motion.div>
        </div>
      </section>

      <section className="section-shell border-b border-white/10" data-id="element-355" data-mp="pa8arshri2qo">
        <div className="container mx-auto max-w-4xl px-6 md:px-12" data-id="element-356" data-mp="l9espfr03i5p">
          <div className="border border-white/10" data-id="element-357" data-mp="z1l5qsyux90x">
            {faqs.map((faq, index) => {
            const isOpen = openIndex === index;
            const answerId = `faq-answer-${index}`;
            return <div key={faq.question} className="border-b border-white/10 last:border-b-0" data-id="element-358" data-mp="18z8yxegte8gz" data-mpi={index}>
                  <button type="button" onClick={() => setOpenIndex(isOpen ? null : index)} aria-expanded={isOpen} aria-controls={answerId} className="flex w-full items-center justify-between gap-6 p-6 text-left transition-colors hover:bg-white/[0.03] focus:outline-none focus-visible:ring-2 focus-visible:ring-inset focus-visible:ring-white sm:p-7" data-id="element-359" data-mp="13yuus7ic3io8">
                    <span className="flex gap-5" data-id="element-360" data-mp="2emdcumb1g3qe">
                      <span className="pt-0.5 text-[10px] font-medium tracking-[0.2em] text-neutral-600" data-id="element-361" data-mp="2jjna2o4o5jos">
                        0{index + 1}
                      </span>
                      <span className="text-base font-medium tracking-[-0.015em] text-white" data-id="element-362" data-mp="2ol2ymq6228bx">
                        {faq.question}
                      </span>
                    </span>
                    <ChevronDownIcon size={18} className={`shrink-0 text-neutral-400 transition-transform duration-300 ${isOpen ? 'rotate-180' : ''}`} aria-hidden="true" data-id="element-363" data-mp="3shm8pxf1zvb" />
                  </button>
                  <AnimatePresence initial={false} data-id="element-364" data-mp="1oc4n2g93s3jo">
                    {isOpen && <motion.div id={answerId} initial={{
                  height: 0,
                  opacity: 0
                }} animate={{
                  height: 'auto',
                  opacity: 1
                }} exit={{
                  height: 0,
                  opacity: 0
                }} transition={{
                  duration: 0.24,
                  ease: 'easeOut'
                }} data-id="element-365" data-mp="1jj1r61gusi0b">
                        <p className="max-w-2xl px-6 pb-7 pl-14 text-sm leading-relaxed text-neutral-400 sm:px-7 sm:pb-8 sm:pl-[4.9rem]" data-id="element-366" data-mp="2q05jra1jdrkl">
                          {faq.answer}
                        </p>
                      </motion.div>}
                  </AnimatePresence>
                </div>;
          })}
          </div>
        </div>
      </section>

      <section className="section-shell border-b border-white/10 bg-black" data-id="element-367" data-mp="eaz6t20w2hi9">
        <div className="container mx-auto max-w-5xl px-6 md:px-12" data-id="element-368" data-mp="jc6b2r3toyk6">
          <div className="grid overflow-hidden border border-white/10 md:grid-cols-[1fr_auto]" data-id="element-369" data-mp="172itivwp2dp0">
            <div className="p-8 sm:p-10" data-id="element-370" data-mp="1bzj0ra5a5mhp">
              <p className="eyebrow" data-id="element-371" data-mp="1byhk8q5hw7sl">¿Sigues con dudas?</p>
              <h2 className="mt-5 text-3xl font-medium tracking-[-0.04em] text-white" data-id="element-372" data-mp="x29uzbf8cg6g">
                Hablemos de tu caso concreto.
              </h2>
              <p className="mt-4 max-w-xl text-sm leading-relaxed text-neutral-400" data-id="element-373" data-mp="3htimz66alwwp">
                Una conversación breve puede ayudarte a entender si este es el
                momento y el alcance adecuado para tu negocio.
              </p>
            </div>
            <div className="flex items-center border-t border-white/10 p-8 md:border-l md:border-t-0" data-id="element-374" data-mp="24tfh4qug2w1x">
              <Link to="/contacto" className="button-secondary w-full" data-id="element-375" data-mp="1zve0sdoelau5">
                <MessageCircleIcon size={16} aria-hidden="true" data-id="element-376" data-mp="2duncb01nzgrs" /> Contactar
              </Link>
            </div>
          </div>
        </div>
      </section>
      <PageCTA data-id="element-377" data-mp="1m4ikigbkrrgj" />
    </div>;
}